<section class="flex-col justify-center align-center" (click)="onContentClick($event)">
  <h3>{{ heading }}</h3>

  @if (loadError) {
    <p>Sorry, the FAQ could not be loaded. Please try again later.</p>
  }

  @for (category of categories; track category.heading) {
    <h4>{{ category.heading }}</h4>
    <mat-accordion>
      @for (item of category.items; track item.question) {
        <mat-expansion-panel
          [attr.id]="item.id || null"
          [expanded]="!!item.id && expandedId === item.id"
          (opened)="onOpened(item.id)"
          (closed)="onClosed(item.id)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ item.question }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div [innerHTML]="item.html"></div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
</section>
